import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "red",
      d: "M8.102 3.465a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v1.465a1 1 0 0 1-1 1M8 16a1 1 0 0 1-1-1v-1.35a1 1 0 0 1 2 0V15a1 1 0 0 1-1 1"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      fill: "#0064FF",
      d: "M8.25 14.167c-2.02 0-4.063-.81-5.03-2.022a1 1 0 0 1 1.562-1.25c.962 1.21 4.055 1.775 5.66.697.287-.19.947-.632.262-1.965-.605-.547-1.825-.797-2.91-1.022a13.3 13.3 0 0 1-1.972-.5 2.83 2.83 0 0 1-2.073-2.163 3.38 3.38 0 0 1 1.12-3.317c.923-.728 2.5-1.07 4.015-.88 1.323.165 2.405.715 3.045 1.547a1 1 0 1 1-1.58 1.22c-.31-.4-.935-.685-1.712-.782-1.088-.138-2.113.135-2.525.46a1.37 1.37 0 0 0-.42 1.31.825.825 0 0 0 .655.67q.066.015.13.04.843.282 1.72.435c1.425.295 3.052.627 4.052 1.692q.087.093.148.203c1.05 1.9.75 3.662-.835 4.715a5.93 5.93 0 0 1-3.313.912"
    }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }